<template>
  <div
    class="dragDialog"
    ref="dragDialog"
    :style="{ top: top + 'px', left: left + 'px' }"
  >
    <div class="pos_icon">
      <!-- <el-popover placement="bottom-start" trigger="hover">
        <div>弹窗可移动</div> -->
      <img
        slot="reference"
        class="move"
        @mousedown="onMousedown"
        @mouseup="onMouseup"
        src="@/assets/images/customer/move.png"
        :draggable="false"
        alt=""
      />
      <!-- </el-popover> -->
      <i class="el-icon-close" @click="close"></i>
    </div>

    <span class="family_name"
      >{{ obj.family_cnname }}（{{ obj.family_relation }}）</span
    >
    <span class="family_mobile">{{ obj.family_mobile }}</span>
    <template v-if="status === 1">
      <img class="gif" src="@/assets/images/customer/dialing.gif" alt="" />
      <span class="status">呼叫中...</span>
    </template>
    <template v-if="status === 2">
      <img class="gif" src="@/assets/images/customer/recording.gif" alt="" />
      <span class="status">通话录音中</span>
    </template>
    <template v-if="status === 3">
      <img class="gif" src="@/assets/images/customer/phone4-icon.png" alt="" />
      <span class="status">通话结束</span>
    </template>
    <template v-if="status === 4">
      <img class="gif" src="@/assets/images/customer/failed.gif" alt="" />
      <span class="status">呼叫失败</span>
      <p>
        可能的原因为：话机正在通话中、话机没信号、话机网络差、话机停机/关机、xx外呼设备不在线、余额不足
      </p>
      <div class="pos_btn">
        <el-button type="primary" @click="replay">重拨</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "dragDialog",
  props: {
    obj: {},
    status: {
      type: Number,
      isRequired: true,
    },
    width: {
      type: Number,
      isRequired: true,
    },
    height: {
      type: Number,
      isRequired: true,
    },
    e: {},
  },
  components: {},
  data() {
    return {
      isMove: false,
      lastX: 0,
      lastY: 0,
      top: 0,
      left: 0,
    };
  },
  created() {
    this.top = this.height;
    this.left = this.width;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    replay() {
      this.$emit("replay");
    },
    onMousedown(e) {
      this.lastX = e.clientX;
      this.lastY = e.clientY;
      this.isMove = true;
    },
    onMousemove(e) {
      if (this.isMove) {
        let defX = e.clientX - this.lastX;
        let defY = e.clientY - this.lastY;
        this.left += defX || 0;
        this.top += defY || 0;
        this.lastX = e.clientX;
        this.lastY = e.clientY;
      }
    },
    onMouseup() {
      this.isMove = false;
    },
  },
  watch: {
    e() {
      this.onMousemove(this.e);
    },
  },
};
</script>

<style lang="less">
.dragDialog {
  width: 600px;
  min-height: 300px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #e6e9ed;
  position: absolute;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  .pos_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    font-size: 20px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 20px;
      cursor: pointer;
    }
    i {
      cursor: pointer;
    }
  }
  .family_name {
    margin-top: 38px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #333333;
  }
  .family_mobile {
    margin-bottom: 40px;
  }
  .gif {
    width: 68px;
    height: 68px;
    margin-bottom: 20px;
  }
  p {
    font-size: 14px;
    margin: 30px 100px;
  }
  .pos_btn {
    width: 100%;
    height: 66px;
    background: #f6f9fc;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    button {
      width: 96px;
      height: 30px;
    }
  }
}
</style>
